<template>
  <v-container>
    <v-layout>
      <v-flex md3 pt-1>
        Contact pour cette demande
      </v-flex>
      <v-flex md3>
        <v-text-field
          v-model="infosSupplementaire.nomContactDemande"
          autofocus
          single-line
          dense
          outlined
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md3 pt-1>
        Commentaires:
      </v-flex>
      <v-flex md5>
        <v-text-field
          v-model.trim="infosSupplementaire.commentaire"
          single-line
          dense
          counter="250"
          outlined
        />
      </v-flex>
    </v-layout>

    <div class="font-weight-bold">
      SAISIE DES INFORMATIONS SUR LE FOURNISSEUR
    </div>

    <v-divider class="pb-6" />

    <v-layout pb-8>
      <v-flex xs2 class="font-weight-bold">
        <div>No du fournisseur:</div>
        <div>
          <a
            style="text-decoration: underline"
            @click="lireListeFournisseurs()"
            @click.stop="dialogFournisseur = true"
          >
            Voir mes fournisseurs</a
          >
        </div>
      </v-flex>
      <v-flex xs2>
        <v-text-field
          v-model="noFournisseurRecherche"
          v-mask="maskNombres"
          class="pt-0 pr-8"
          append-icon="search"
          hide-details
          autofocus
        />
      </v-flex>
      <v-flex xs2>
        <div class="pt-2">
          <v-btn
            medium
            color="primary"
            style="text-transform: none;"
            :disabled="sending"
            @click="rechercherFournisseur()"
          >
            Rechercher
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- ------------------ -->
    <!---------- Dialog ------>
    <!-- ------------------ -->
    <v-dialog v-model="dialogFournisseur" width="400">
      <v-card>
        <v-layout>
          <v-flex md12>
            <v-card-title style="font-size: 18px" class="grey lighten-2"
              >Liste de mes fournisseurs</v-card-title
            >
          </v-flex>
        </v-layout>

        <v-flex xs12 pt-5>
          <v-layout>
            <table>
              <v-flex v-for="item in listeFournisseur" :key="item.id" pl-8 pb-4>
                <a
                  style="text-decoration: underline;"
                  class="font-weight-bold"
                  @click="fournisseurSelectionne(item.noFournisseurJDE)"
                >
                  {{ item.noFournisseurJDE }}
                </a>
                <div>{{ item.nomFournisseur }}</div>
                <div>
                  {{ item.adresse1 }}, {{ item.villeRegion }},
                  {{ item.provinceEtat }},
                  {{ item.codePostal }}
                  {{ item.pays }}
                </div>
              </v-flex>
            </table>
          </v-layout>
        </v-flex>

        <v-btn
          class="mt-10 mb-5"
          text
          color="primary"
          dark
          @click="dialogFournisseur = false"
          >Fermer</v-btn
        >
      </v-card>
    </v-dialog>

    <v-col class="font-weight-bold">
      <div>ADRESSE DU LIEU D'ENLÈVEMENT</div>
    </v-col>
    <v-divider class="pb-6" />

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Nom
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.nom }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Adresse
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.adresseLigne1 }}
      </v-col>
    </v-row>

    <v-row
      v-if="infosFournisseur.informationEnlevement.adresseLigne2 != null"
      class="pl-10"
    >
      <v-col cols="1" sm="2" class="font-weight-bold pa-0" />
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.adresseLigne2 }}
      </v-col>
    </v-row>

    <v-row
      v-if="infosFournisseur.informationEnlevement.adresseLigne2 != null"
      class="pl-10"
    >
      <v-col cols="1" sm="2" class="font-weight-bold pa-0" />
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.adresseLigne2 }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Ville, Région
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.villeRegion }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Pays
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.pays }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Province/Région
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.provinceEtat }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Code postal
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.codePostal }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Téléphone 1
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.tel1 }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Téléphone 2
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.tel2 }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Courriel
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationEnlevement.courriel }}
      </v-col>
    </v-row>

    <v-col class="pt-8 font-weight-bold">
      <div>ADRESSE ADMINISTRATIVE</div>
    </v-col>
    <v-divider class="pb-6" />

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        No fournisseur
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.noFournisseur }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Nom
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.nom }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Adresse
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.adresseLigne1 }}
      </v-col>
    </v-row>

    <v-row
      v-if="infosFournisseur.informationsAdminstratives.adresseLigne2 != null"
      class="pl-10"
    >
      <v-col cols="1" sm="2" class="font-weight-bold pa-0" />
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.adresseLigne2 }}
      </v-col>
    </v-row>

    <v-row
      v-if="infosFournisseur.informationsAdminstratives.adresseLigne2 != null"
      class="pl-10"
    >
      <v-col cols="1" sm="2" class="font-weight-bold pa-0" />
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.adresseLigne2 }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Ville, Région
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.villeRegion }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Pays
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.pays }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Province/Région
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.provinceEtat }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Code postal
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.codePostal }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Téléphone 1
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.tel1 }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Téléphone 2
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.tel2 }}
      </v-col>
    </v-row>

    <v-row class="pl-10">
      <v-col cols="1" sm="2" class="font-weight-bold pa-0">
        Courriel
      </v-col>
      <v-col cols="1" sm="3" class="pa-0">
        {{ infosFournisseur.informationsAdminstratives.courriel }}
      </v-col>
    </v-row>

    <v-col class="pt-8 font-weight-bold">
      <div>
        TERMES D'ACHATS ET INFORMATIONS SUR LES DÉLAIS D'APPROVISIONNEMENT
      </div>
    </v-col>
    <v-divider class="pb-6" />

    <i>
      Pour connaître le délai approximatif d'approvisionnement, sélectionnez le
      pays d'expédition
    </i>
    <div>Délai d'approvisionnement :</div>
    <div>
      Les délais d'approvisionnement entre la réception de la demande de
      commande privée et la mise en disponibilité des produits peuvent varier de
      11 à 13 semaine(s).
    </div>
    <div>
      Veuillez noter que ces délais ne sont pas garantis et que plusieurs
      facteurs peuvent les influencer (ex. : disponibilité des produits au pays
      d'origine, délai de groupage, délai de réception, etc.).
    </div>

    <v-radio-group v-model="termeAchat" ml-4>
      <v-radio value="FCA" @change="majTermeAchat('FCA')">
        <template v-slot:label>
          <div class="font-weight-bold">
            Terme d'achat FCA - transport assuré par la SAQ à partir du lieu
            d'enlèvement désigné par la SAQ
          </div>
        </template>
      </v-radio>

      <v-radio value="DDU" @change="majTermeAchat('DDU')">
        <template v-slot:label>
          <div class="font-weight-bold">
            Terme d'achat DDU - transport assuré par avion par le fournisseur
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <i
      >La SAQ assure le transport du lieu d'expédition (indiqué sur le bon de
      commande) à l'entrepôt de la SAQ. Les frais d'exportation douanière du
      pays d'origine sont aux frais du fournisseur ainsi que le chargement de sa
      marchandise. Il est à noter que si l'adresse d'enlèvement est différente
      du pays producteur, le fournisseur doit s'assurer que les frais de douane
      soient assumés dans les deux pays.</i
    >
    <div class="pt-3">
      <i
        >Pour plus d'informations, veuillez vous référer au site officiel des
        incoterms 2000 :
        <a
          href="#"
          onClick="window.open('http://www.iccwbo.org/incoterms/id3040/index.html', '_blank')"
          >http://www.iccwbo.org/incoterms/id3040/index.html</a
        >
      </i>
    </div>
    <div>
      <i
        >Pour une référence en français :
        <a
          href="#"
          onClick="window.open('http://fr.icom7.com/tutoriels/incoterms_2000.php', '_blank')"
          >http://fr.icom7.com/tutoriels/incoterms_2000.php</a
        >
      </i>
    </div>
  </v-container>
</template>

<script>
import { mask } from '@titou10/v-mask'
export default {
  name: 'StepFournisseur',
  directives: { mask },
  data() {
    return {
      noFournisseurRecherche: null,
      dialogFournisseur: false,
      listeFournisseur: [],
      sending: false,
      maskNombres: '########',
      termeAchat: {}
    }
  },

  computed: {
    infosSupplementaire: function() {
      return this.$store.getters.infosSupplementaire
    },
    infosFournisseur: function() {
      return this.$store.getters.demande.infosFournisseur
    }
  },

  beforeMount() {
    this.$store.dispatch('initialiserInfosSupplementaire')
    this.$store.getters.demande.termeAchat = 'FCA'
  },

  methods: {
    majTermeAchat(value) {
      this.$store.getters.demande.termeAchat = value
    },

    rechercherFournisseur() {
      if (this.$route.params.noFournisseurRecherche != null) {
        this.noFournisseurRecherche = this.$route.params.noFournisseurRecherche
      }

      if (!this.noFournisseurRecherche) {
        this.$store.dispatch(
          'afficherInfo',
          'Veuillez sélectionner un fournisseur'
        )
        return
      }

      this.sending = true

      console.log('Demande chercher fournisseur ', this.noFournisseurRecherche)
      this.infosFournisseur.informationEnlevement = []
      this.infosFournisseur.informationsAdminstratives = []

      axios
        .get(
          `/fournisseurs/obtenirinfosfournisseurselonclient/${this.noFournisseurRecherche}/${this.$store.getters.currentUser.clientData.idDemandeur}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.getters.demande.infosFournisseur = resp.resultat
              this.obtenirDevise()
              this.obtenirListeProduitsSelonFournisseur()
              break
            case 'V015':
              this.$store.dispatch(
                'afficherInfo',
                "Ce fournisseur n'existe pas dans votre liste"
              )
              break
            case 'X001':
              this.$store.dispatch(
                'afficherInfo',
                'Il y a un problème à récupérer les informations du fournisseur'
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    obtenirDevise() {
      console.log('obtenirDevise ')

      var codeDevise = this.deviseFournisseur()

      axios
        .get(`/devise/${codeDevise}`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.getters.demande.tauxDevise = resp.resultat

              break
            case 'W001':
              this.$store.dispatch(
                'afficherInfo',
                "Cette devise n'est pas une devise reconnue"
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          this.agents = []
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    deviseFournisseur() {
      if (this.infosFournisseur.informationEnlevement.devise != null) {
        return this.infosFournisseur.informationEnlevement.devise
      } else if (
        this.infosFournisseur.informationsAdminstratives.devise != null
      ) {
        return this.infosFournisseur.informationsAdminstratives.devise
      }
    },

    obtenirListeProduitsSelonFournisseur() {
      if (this.infosFournisseur.informationEnlevement.length == 0) {
        this.$store.dispatch(
          'afficherInfo',
          'Vous devez sélectionner un fournisseur pour la liste de produits'
        )
        return
      }

      var noFournisseur
      if (this.infosFournisseur.informationEnlevement.noFournisseur != null) {
        noFournisseur = this.infosFournisseur.informationEnlevement
          .noFournisseur
      } else {
        noFournisseur = this.infosFournisseur.informationsAdminstratives
          .noFournisseur
      }

      console.log('obtenirListeProduitsSelonFournisseur ' + noFournisseur)

      axios
        .get(
          `/demande/obtenirDemandeProduit/${this.$store.getters.currentUser.clientData.idDemandeur}/${noFournisseur}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.getters.demande.listeProduits = resp.resultat
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    lireListeFournisseurs() {
      this.listeFournisseur = []
      axios
        .get(
          `/fournisseurs/listefournisseurpourclient/${this.$store.getters.currentUser.clientData.idDemandeur}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeFournisseur = resp.resultat
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    fournisseurSelectionne(idFournisseur) {
      console.log('fournisseurSelectionne ' + idFournisseur)

      this.noFournisseurRecherche = idFournisseur
      this.dialogFournisseur = false
    }
  }
}
</script>

<style scoped>
div {
  font-size: 14px;
  color: black;
}

span {
  font-size: 14px;
  color: black;
}

.lien {
  height: 28px;
  width: 26.01px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 28px;
}

.texteSansCategorieDepot {
  font-weight: bold;
  font-size: 14px;
}

.v-text-field--outlined >>> fieldset {
  border-color: black;
  border-width: 1.5px;
}
</style>
